import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { dataDefault } from 'Components/User/Pickups/BulkoBag'
import { apiPickupsList, apiPickupsView } from 'Services/UserService'

export const getData = createAsyncThunk('user/pickups/getData', async datas => {
    const { data } = await apiPickupsList(datas)
    return data
})

export const getView = createAsyncThunk('user/pickups/getView', async id => {
    if (!id) return viewData
    const { data } = await apiPickupsView(id)
    data.pickup_bulko_bag = data.pickup_bulko_bag && data.pickup_bulko_bag.length !== 0 ? data.pickup_bulko_bag : [dataDefault]
    return data
})

const viewData = {
    name: '',
    pickup_bulko_bag: [dataDefault],
}

export const pickupsSlice = createSlice({
    name: 'user/pickups',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            start: moment().startOf('month').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('month').locale('en').format('YYYY-MM-DD'),
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.start = start
            state.table.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate } = pickupsSlice.actions

export default pickupsSlice.reducer
